/**
 * Loading state component
 */

import { useTranslation } from 'react-i18next';

export default function LoadingState() {
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950">
      {/* Animated background gradient orbs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 -left-4 w-96 h-96 bg-waffle-orange/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob"></div>
        <div className="absolute top-0 -right-4 w-96 h-96 bg-amber-500/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000"></div>
      </div>

      <div className="relative text-center space-y-6">
        <div className="animate-spin rounded-full h-10 w-10 sm:h-12 sm:w-12 border-4 border-waffle-orange border-t-transparent mb-4 mx-auto"></div>
        <p className="text-white font-medium text-sm sm:text-base">{t('loadingState.loadingPost')}</p>

        {/* Download buttons on loading state */}
        <div className="pt-4">
          <p className="text-xs sm:text-sm text-gray-400 mb-3">{t('loadingState.sharePrompt')}</p>
          <div className="flex flex-row gap-2 justify-center">
            <a
              href="https://apps.apple.com/app/family-waffle"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-3 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition-all min-h-[44px]"
            >
              <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div className="text-left">
                <div className="text-[8px] leading-tight opacity-90">{t('loadingState.downloadOnThe')}</div>
                <div className="text-xs font-semibold leading-tight">{t('loadingState.appStore')}</div>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.familywaffle"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-3 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition-all min-h-[44px]"
            >
              <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              <div className="text-left">
                <div className="text-[8px] leading-tight opacity-90">{t('loadingState.getItOn')}</div>
                <div className="text-xs font-semibold leading-tight">{t('loadingState.googlePlay')}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
